import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useCheckboxConfig = (checkbox: 'One' | 'Two') => {
  const { t } = useTranslation();

  const text = t(`pages.bidSheet.bidSummaryModal.checkbox${checkbox}__markdownEnabled`);
  const visible = text !== '';

  const [checked, setChecked] = useState(!visible);
  const toggleChecked = useCallback(() => setChecked((v) => !v), [setChecked]);

  return { text, visible, checked, setChecked, toggleChecked };
};

const useSummaryCheckboxes = () => {
  const checkboxOneConfig = useCheckboxConfig('One');
  const checkboxTwoConfig = useCheckboxConfig('Two');

  return { checkboxOneConfig, checkboxTwoConfig } as const;
};

export default useSummaryCheckboxes;
